<form novalidate [formGroup]="form" (keyup.enter)="onFormSubmit()" (ngSubmit)="onFormSubmit()" class="form">
 
  <ion-list>

    <ion-item class="ion-no-padding" mode="md">
      <ion-label position="stacked" mode="md">{{ 'REGISTRATION.NAME' | translate }}</ion-label>
      <ion-input placeholder="{{ 'REGISTRATION.NAME_PLACEHOLDER' | translate }}" formControlName="firstName" (focus)="firstNameFocus=true;" (blur)="firstNameFirstBlur=true; firstNameFocus=false;" type="text" tabindex="10" [ngClass]="{
        'is-invalid': firstName.invalid && ( firstNameFirstBlur || tryToSubmit )
      }"></ion-input>

    </ion-item>
    <div class="invalid-feedback" *ngIf="firstName.invalid && ( firstNameFirstBlur || tryToSubmit ) && !!firstName.errors?.required">
        {{ 'REGISTRATION.NAME_IS_REQUIRED' | translate }}
    </div>

    <ion-item class="ion-no-padding" mode="md">
      <ion-label position="stacked" mode="md">{{ 'REGISTRATION.SURNAME' | translate }}</ion-label>
      <ion-input placeholder="{{ 'REGISTRATION.SURNAME_PLACEHOLDER' | translate }}" formControlName="lastName" (focus)="lastNameFocus=true;" (blur)="lastNameFirstBlur=true; lastNameFocus=false;" type="text" tabindex="3" [ngClass]="{
        'is-invalid': lastName.invalid && ( lastNameFirstBlur || tryToSubmit )
      }"></ion-input>

    </ion-item>
    <div class="invalid-feedback" *ngIf="lastName.invalid && ( lastNameFirstBlur || tryToSubmit ) && !!lastName.errors?.required">
        {{ 'REGISTRATION.SURNAME_IS_REQUIRED' | translate }}
    </div>

    <ion-item class="ion-no-padding" mode="md">
      <ion-label position="stacked" mode="md">{{ 'REGISTRATION.EMAIL' | translate }}</ion-label>
      <ion-input placeholder="{{ 'REGISTRATION.EMAIL_PLACEHOLDER' | translate }}" formControlName="email" (focus)="emailFocus=true;" (blur)="emailFirstBlur=true; emailFocus=false;" type="email" tabindex="10" [ngClass]="{
        'is-invalid': email.invalid && ( emailFirstBlur || tryToSubmit )
      }"></ion-input>

    </ion-item>
    <div class="invalid-feedback" *ngIf="email.invalid && ( emailFirstBlur || tryToSubmit ) && !!email.errors?.required">
      {{ 'REGISTRATION.ERR_EMAIL_REQUIRED' | translate }}
    </div>
    <div class="invalid-feedback" *ngIf="email.invalid && !emailFocus && !!email.errors?.pattern && !email.errors?.required">
      {{ 'REGISTRATION.ERR_EMAIL_WRONG_FORMAT' | translate }}
    </div>

  <section formGroupName="matchingPasswords">

    <ion-item class="ion-no-padding" mode="md">
      <ion-label  position="stacked" mode="md">{{ 'REGISTRATION.PASSWORD' | translate }}</ion-label>
      <ion-input placeholder="{{ 'REGISTRATION.PASSWORD_PLACEHOLDER' | translate }}"formControlName="password" (focus)="passwordFocus=true;" (blur)="passwordFirstBlur=true; passwordFocus=true" tabindex="11" type="password"  [ngClass]="{
          'is-invalid': password.invalid && password.errors?.required && tryToSubmit
        }"></ion-input>
    </ion-item>
    
    <div class="invalid-feedback" *ngIf="password.invalid && password.errors?.required && tryToSubmit">
      {{ 'REGISTRATION.ERR_PASSWORD_REQUIRED' | translate }}
    </div>
    <div class="invalid-feedback" *ngIf="password.invalid && !!password.errors?.minlength">
      {{ 'REGISTRATION.ERR_PASSWORD_LENGTH' | translate }}
    </div>

    <ion-item class="ion-no-padding" mode="md">
      <ion-label position="stacked" mode="md">{{ 'REGISTRATION.PASSWORD_REPEAT' | translate }}</ion-label>
      <ion-input placeholder="{{ 'REGISTRATION.PASSWORD_REPEAT_PLACEHOLDER' | translate }}" formControlName="confirmPassword" (focus)="confirmPasswordFocus=true;" (blur)="confirmPasswordFirstBlur=true; confirmPasswordFocus=false" tabindex="11" type="password"  [ngClass]="{
        'is-invalid': ( confirmPassword.invalid || matchingPasswords.invalid ) && ( confirmPasswordFirstBlur || tryToSubmit )
      }"></ion-input>
    </ion-item>

     <div class="invalid-feedback" *ngIf="confirmPassword.invalid && confirmPassword.errors?.required && tryToSubmit">
      {{ 'REGISTRATION.ERR_REPEAT_PASSWORD_REQUIRED' | translate }}
    </div>
    <div class="invalid-feedback" *ngIf="matchingPasswords.invalid && !password.invalid && !confirmPassword.invalid && ( passwordFirstBlur || tryToSubmit )">
      {{ 'REGISTRATION.ERR_REPEAT_PASSWORD_NOT_THE_SAME' | translate }}
    </div>

  </section>

  </ion-list>

  <ion-button *ngIf="!(loading$ | async)" [disabled]="!form.valid"  type="submit" class="btn--large" expand="full" tabindex="12"> {{ 'REGISTRATION.BTN_EMAIL_REGISTRATION' | translate }} </ion-button>
  <ion-button *ngIf="loading$ | async"  type="submit" class="btn--large" expand="full" disabled="true"><ion-spinner name="crescent"></ion-spinner></ion-button>

</form>

<ion-item  class="ion-no-padding">
  <p class="ion-text-center register-prompt">{{ 'REGISTRATION.ALREADY_REGISTERED' | translate }} <a [routerLink]="['/auth', 'prijava']" class="pp-link">{{ 'REGISTRATION.LOGIN' | translate }}</a>
  </p>
</ion-item>

<p class="ion-text-center text--tos">{{ 'REGISTRATION.DISCLAIMER' | translate }}<br>{{ 'REGISTRATION.DISCLAIMER_MORE' | translate }} <a [routerLink]="['/info', 'zasebnost']">{{ 'REGISTRATION.DISCLAIMER_POLICY' | translate }}</a>.</p>


